import axios from "axios";
const base = (process.env.REACT_APP_API_BASE_URL || "http://localhost:8080") + "/api/health-treatment";
const client = () => axios.create({baseURL:base,headers:{
  "Content-Type":"application/json", Authorization:`Bearer ${localStorage.getItem('authToken') || ''}`,
}});
const healthTreatmentService = {
  groups: async () => (await client().get('/medicine-groups')).data,
  saveGroup: async (data,id) => (await (id ? client().put(`/medicine-groups/${id}`,data) : client().post('/medicine-groups',data))).data,
  archiveGroup: async id => (await client().patch(`/medicine-groups/${id}/archive`)).data,
  preventives: async () => (await client().get('/preventive')).data,
  archivePreventive: async id => (await client().patch(`/preventive/${id}/archive`)).data,
  submit: async request => (await client().post('/submit',request)).data,
};
export default healthTreatmentService;
